import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

import { cn } from '@/lib/utils';

// Egységes Popover — a dropdown-menü/select floating-tier stílusát követi (`dark-surface-popover`:
// elevated felület + neutrális lift-árnyék, mindkét témában). Tetszőleges tartalmi popover (szűrő-panel,
// mini-form) hordozója; a menü-szemantikájú listákhoz továbbra is a DropdownMenu a helyes választás.
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    /** `false` → NINCS portál (a tartalom a helyén, a trigger DOM-fáján belül renderel). A Radix popper
     *  `position: fixed`, ezért így sem vágja el az overflow. Modális Sheet/Dialog BELSEJÉBEN ez kell a
     *  görgethető listákhoz: a portálozott (body-szintű) popovert a Dialog `react-remove-scroll`-ja blokkolná. */
    portal?: boolean;
  }
>(({ className, align = 'center', sideOffset = 4, portal = true, ...props }, ref) => {
  const content = (
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'dark-surface-popover text-popover-foreground z-50 rounded-lg border p-3 outline-none',
        'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
        className,
      )}
      {...props}
    />
  );
  return portal ? <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal> : content;
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };
